import {enableProdMode,
  ErrorHandler,
  importProvidersFrom,
  inject,
  Injector,
  provideAppInitializer,
  provideZoneChangeDetection} from '@angular/core';

import {environment} from './environments/environment';
import {AppComponent} from './app/app.component';
import {RouterModule} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {PERMISSION_SERVICE} from './app/shared/services/permission/permission.service';
import {AppRoutingModule, loadRoutes} from './app/app-routing.module';
import {ApiErrorInterceptor} from './app/shared/interceptors/api-error.interceptor';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {AUTHENTICATION_SERVICE} from './app/shared/services/authentication/authentication.service';
import {CaseConverterInterceptor} from './app/shared/interceptors/case-converter.interceptor';
import {SpinnerInterceptor} from './app/shared/interceptors/spinner-interceptor';
import {DatePipe} from '@angular/common';
import {CART_LOAD_SERVICE} from './app/prudent-plus-shared/services/cart/cart-load.service';
import {EMPLOYEE_LOAD_SERVICE} from './app/prudent-plus-shared/services/employee/employee-load.service';
import {ENVIRONMENT} from './environments/environment.token';
import {GlobalErrorHandler} from './app/shared/error-handler/global-error-handler';
import {ToastInterceptor} from './app/shared/interceptors/toast-interceptor';
import {NAV_BAR_SERVICE} from './app/shared/views/nav-bar/nav-bar.service';
import {ApiResponseSizeInterceptor} from './app/shared/interceptors/api-response-size.interceptor';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      ...environment.appConfig.modules,
      RouterModule
    ),
    ...environment.appConfig.providers ?? [],
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CaseConverterInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiResponseSizeInterceptor,
      multi: true,
    },
    provideAppInitializer(async () => {
      const initializerFn = loadRoutes(inject(Injector));

      await Promise.resolve(initializerFn());
    }),
    {
      provide: AUTHENTICATION_SERVICE,
      useClass: environment.appConfig.classOverrides.authenticationService,
    },
    {
      provide: PERMISSION_SERVICE,
      useClass: environment.appConfig.classOverrides.hasPermission,
    },
    {
      provide: CART_LOAD_SERVICE,
      useClass: environment.appConfig.classOverrides.cartLoadService,
    },
    {
      provide: EMPLOYEE_LOAD_SERVICE,
      useClass: environment.appConfig.classOverrides.employeeLoadService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ToastInterceptor,
      multi: true,
    },
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    {
      provide: NAV_BAR_SERVICE,
      useClass: environment.appConfig.classOverrides.navbarService,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-US',
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
  ],
})
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
